import React from 'react'
import LoginContainer from './LoginContainer'
import { Route } from 'react-router-dom'
import EmptyPage from '../../../layout/component/EmptyPage'


const PrivateRoute = ({ user, component: Component, exact, path, hasRole, requiredRole, ...props }) => {
    return <Route exact={exact} path={path} render={() => {
        if (user && (hasRole || !requiredRole)) {
            return <Component {...props}/>
        }

        if (user && !hasRole) {
            return <EmptyPage/>
        }

        return <LoginContainer/>
    }}/>
}

export default PrivateRoute



// WEBPACK FOOTER //
// ./src/modules/security/component/auth/PrivateRoute.js